export const ADMIN_SESSION_EXPIRED = 'admin-session-expired';

// A delayed response from an old session must not invalidate a newer login.
export function handleUnauthorizedResponse(response, token) {
  if (response.status !== 401 || !token || localStorage.getItem('adminToken') !== token) return;
  localStorage.removeItem('adminToken');
  localStorage.removeItem('adminData');
  window.dispatchEvent(new Event(ADMIN_SESSION_EXPIRED));
}
